export default __webpack_public_path__ + "static/media/kitchen4-afterD-2048w.e6b2fb2c.webp";